import { render, staticRenderFns } from "./MockContent.vue?vue&type=template&id=3d1de70c&"
import script from "./MockContent.vue?vue&type=script&lang=js&"
export * from "./MockContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports